import { render, staticRenderFns } from "./AssetUpload.vue?vue&type=template&id=09653046&"
import script from "./AssetUpload.vue?vue&type=script&lang=ts&"
export * from "./AssetUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports